module.exports = __webpack_public_path__ + "img/Wagner-HR-199x200.813f9bae.png";